import { registerModal } from "libs/modals";
import { FrontifyMediaModal } from "./frontify-media";

export { FrontifyMediaModal } from "./frontify-media";

// FRONTIFY MODEL
export const ADD_FRONTIFY_MODAL = "ADD_FRONTIFY_MODAL";
registerModal(ADD_FRONTIFY_MODAL, FrontifyMediaModal);
